<ng-template #pageTitle>
  <h5 class="text-neutral-900 font-semibold text-2xl ps-2xl">
    {{ 'my_inbox_screen_title' | transloco }}
  </h5>
</ng-template>

<div class="h-full flex flex-col" [class]="systemTabsPageClasses()">
  <div class="flex flex-col gap-2xl">
    @if (!floating()) {
      <ng-container [ngTemplateOutlet]="pageTitle" />
    }

    <lib-tabs
      [tabSegmented]="systemTabs()"
      [tabsStartRef]="floating() ? pageTitle : null"
      [tabsHeaderClass]="floating() ? 'mb-lg' : ''"
      [tabPill]="!systemTabs()"
      [tabsBorder]="!systemTabs()"
      [tabsClass]="systemTabs() ? '' : 'border-neutral-200 pb-2xl'"
      (selectTab)="resetSearchAndFilterOnTabChange()"
      [enableTabRouting]="true">
      <lib-tab
        [tabTitle]="'my_inbox_screen_first_tab_label' | transloco"
        [showTabTag]="true"
        [tabTag]="assignedToMeTabTag()"
        [tabRoutingParam]="inboxTabRoutingParam.assignedToMe"
        #assignedToMeTab>
        @if (assignedToMeTab.active()) {
          @if (delegatedToMeTabEnabled()) {
            <lib-assigned-to-me />
          } @else {
            <lib-assigned-inbox
              [assignedCount]="insights().assigned_to_user_count"
              [delegatedCount]="insights().delegated_tasks_count ?? 0"
              (counterRefresh)="getTabsInsight()" />
          }
        }
      </lib-tab>

      @if (delegatedToMeTabEnabled()) {
        <lib-tab
          [tabTitle]="'my_inbox_screen_task_delegation_tab_label' | transloco"
          [showTabTag]="true"
          [tabTag]="delegatedToMeTabTag()"
          [tabRoutingParam]="inboxTabRoutingParam.delegatedToMe"
          #delegatedToMeTab>
          @if (delegatedToMeTab.active()) {
            <lib-delegated-to-me />
          }
        </lib-tab>
      }

      <lib-tab
        [tabTitle]="'my_inbox_screen_second_tab_label' | transloco"
        [showTabTag]="true"
        [tabTag]="insights().created_by_user_count"
        [tabRoutingParam]="inboxTabRoutingParam.createdByMe"
        #createdByMeTab>
        @if (createdByMeTab.active()) {
          <lib-created-by-me
            (counterRefresh)="getTabsInsight(); actionSourceTabName.set($event)"
            [actionSourceTabName]="actionSourceTabName()" />
        }
      </lib-tab>

      <lib-tab
        [tabTitle]="'my_inbox_screen_third_tab_label' | transloco"
        [showTabTag]="true"
        [tabTag]="insights().all_participated_user_count"
        [tabRoutingParam]="inboxTabRoutingParam.allParticipated"
        #allParticipatedTab>
        @if (allParticipatedTab.active()) {
          <lib-all-participated
            (counterRefresh)="getTabsInsight(); actionSourceTabName.set($event)"
            [actionSourceTabName]="actionSourceTabName()" />
        }
      </lib-tab>

      <lib-tab
        [tabTitle]="'my_inbox_screen_collaborated_tasks_tab_label' | transloco"
        [showTabTag]="true"
        [tabTag]="insights().collaborated_user_count"
        [tabRoutingParam]="inboxTabRoutingParam.collaboratedTasks"
        #collaboratedTasksTab>
        @if (collaboratedTasksTab.active()) {
          <lib-collaborated-tasks
            (counterRefresh)="getTabsInsight(); actionSourceTabName.set($event)"
            [actionSourceTabName]="actionSourceTabName()" />
        }
      </lib-tab>

      <lib-tab
        [tabTitle]="'my_inbox_screen_contributed_tasks_tab_label' | transloco"
        [showTabTag]="true"
        [tabTag]="insights().contributed_user_count"
        [tabRoutingParam]="inboxTabRoutingParam.contributedTasks"
        #contributedTasksTab>
        @if (contributedTasksTab.active()) {
          <lib-contributed-tasks (counterRefresh)="getTabsInsight()" />
        }
      </lib-tab>
    </lib-tabs>
  </div>
</div>
